"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BasePeer = void 0;
const tslib_1 = require("tslib");
const types_1 = require("./types");
const uuid_1 = require("./utils/uuid");
const debugger_1 = require("./utils/debugger");
const events_1 = require("events");
const common_1 = require("@gameglass/common");
class BasePeer {
    constructor(peer, cb, wrtc, debug) {
        this._peers = [];
        this.eventEmitter = new events_1.EventEmitter();
        this._trickle = false;
        this.noopReceived = false;
        this.sendToPeerWhenReady = new common_1.Queue();
        this._peers.push(peer);
        this._uuid = peer.uuid || (0, uuid_1.uuidv4)();
        this._cb = cb;
        this._wrtc = wrtc;
        this.debugger = new debugger_1.Debugger(debug || false, this.eventEmitter);
        this.addEventListeners(peer);
    }
    get uuid() {
        return this._uuid;
    }
    set uuid(uuid) {
        this._peers.forEach((peer) => {
            peer.uuid = uuid;
        });
        this._uuid = uuid;
    }
    get connected() {
        for (const peer of this._peers) {
            if (peer.connected) {
                return true;
            }
        }
        return false;
    }
    get hasPeers() {
        return this._peers.length !== 0;
    }
    get peer() {
        for (const peer of this._peers) {
            if (peer.connected) {
                return peer;
            }
        }
        return this._peers[this._peers.length - 1];
    }
    get lastValidPeer() {
        return this._peers.slice().reverse().find(peer => {
            if (peer.destroyed) {
                this.closePeer(peer);
                return false;
            }
            return true;
        });
    }
    send(message) {
        try {
            if (this.peer._channelReady) {
                this.debugger.info({
                    title: "sendToWebRTC",
                    args: { message, peer: this.peer }
                });
                return this.peer.send(JSON.stringify(message));
            }
            else {
                this.debugger.warn({
                    title: "noPeerAvailableToSend",
                    args: { message, peer: this.peer }
                });
            }
        }
        catch (error) {
            this.debugger.error({
                title: types_1.LogTypes.sendError,
                args: { error, message, peer: this.peer }
            });
        }
    }
    addPeer(peer) {
        peer.trickle = this._trickle;
        this._peers.push(peer);
        this.addEventListeners(peer);
    }
    addEventListeners(peer) {
        peer.on(types_1.PeerEvents.error, (error) => {
            this.debugger.error({
                title: "Peer eventListener error",
                args: error
            });
            this._peers = this._peers.reduce((newPeers, peer) => {
                if (peer && !peer.destroyed) {
                    newPeers.push(peer);
                }
                else {
                    peer && this.closePeer(peer);
                }
                return newPeers;
            }, []);
        });
        peer.on(types_1.PeerEvents.connect, (event) => {
            this.debugger.warn({
                title: "Peer eventListener connect",
                args: event
            });
            this._peers = this._peers.reduce((newPeers, peer) => {
                if (peer === null || peer === void 0 ? void 0 : peer.connected) {
                    newPeers.push(peer);
                }
                else {
                    peer && this.closePeer(peer);
                }
                return newPeers;
            }, []);
            this.debugger.warn({
                title: "Peer eventListener connect peers",
                args: this._peers
            });
        });
    }
    getSelectedCandidatePair() {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            if ((_c = (_b = (_a = this.peer._pc) === null || _a === void 0 ? void 0 : _a.sctp) === null || _b === void 0 ? void 0 : _b.transport) === null || _c === void 0 ? void 0 : _c.iceTransport) {
                try {
                    return (_g = (_f = (_e = (_d = this.peer._pc) === null || _d === void 0 ? void 0 : _d.sctp) === null || _e === void 0 ? void 0 : _e.transport) === null || _f === void 0 ? void 0 : _f.iceTransport) === null || _g === void 0 ? void 0 : _g.getSelectedCandidatePair();
                }
                catch (error) {
                    this.debugger.debug({
                        title: "getSelectedCandidatePeer not implemented",
                        args: error
                    });
                }
            }
            try {
                const stats = (yield ((_h = this.peer._pc) === null || _h === void 0 ? void 0 : _h.getStats())) || [];
                const candidate = Object.values(stats || []).find((stat) => stat.type === "candidate-pair" && stat.state === "succeeded" && stat.nominated);
                return {
                    local: stats === null || stats === void 0 ? void 0 : stats[candidate.localCandidateId],
                    remote: stats === null || stats === void 0 ? void 0 : stats[candidate.remoteCandidateId]
                };
            }
            catch (error) {
                this.debugger.error({ title: "Selected candidate error: ", args: error });
                return;
            }
        });
    }
    removePeers() {
        this._peers.forEach(peer => this.closePeer(peer));
    }
    closePeer(peer) {
        var _a, _b;
        this.debugger.debug({ title: `Close peer`, args: peer.uuid });
        try {
            (_b = (_a = peer._pc) === null || _a === void 0 ? void 0 : _a.close) === null || _b === void 0 ? void 0 : _b.call(_a);
            peer.removeAllListeners();
            peer.end();
            peer.destroy();
        }
        catch (error) {
            this.debugger.error({
                title: types_1.LogTypes.peerDestroyError,
                args: { error }
            });
        }
    }
}
exports.BasePeer = BasePeer;
//# sourceMappingURL=peer.js.map